import React from 'react';

const EditorToolbar = ({ editor }) => {
  if (!editor) return null;

  const btnStyle = (isActive) => ({
    padding: '6px 10px',
    borderRadius: '6px',
    border: '1px solid var(--border-color)',
    background: isActive ? 'var(--accent-subtle-bg)' : 'var(--bg-secondary)',
    color: isActive ? 'var(--accent-primary)' : 'var(--text-secondary)',
    fontSize: '14px',
    fontWeight: isActive ? '700' : '500',
    cursor: 'pointer',
    fontFamily: 'inherit',
    minWidth: '32px',
    transition: 'all 0.15s ease'
  });

  return (
    <div style={{
      display: 'flex', gap: '4px', padding: '8px 12px',
      borderBottom: '1px solid var(--border-light)',
      background: 'var(--bg-card)', flexWrap: 'wrap'
    }}>
      <button style={btnStyle(editor.isActive('bold'))} onClick={() => editor.chain().focus().toggleBold().run()} title="Bold"><strong>B</strong></button>
      <button style={btnStyle(editor.isActive('italic'))} onClick={() => editor.chain().focus().toggleItalic().run()} title="Italic"><em>I</em></button>
      <button style={btnStyle(editor.isActive('underline'))} onClick={() => editor.chain().focus().toggleUnderline().run()} title="Underline"><span style={{ textDecoration: 'underline' }}>U</span></button>
      <div style={{ width: '1px', background: 'var(--border-color)', margin: '0 4px' }} />
      <button style={btnStyle(editor.isActive('heading', { level: 1 }))} onClick={() => editor.chain().focus().toggleHeading({ level: 1 }).run()} title="Heading 1">H1</button>
      <button style={btnStyle(editor.isActive('heading', { level: 2 }))} onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()} title="Heading 2">H2</button>
      <button style={btnStyle(editor.isActive('heading', { level: 3 }))} onClick={() => editor.chain().focus().toggleHeading({ level: 3 }).run()} title="Heading 3">H3</button>
    </div>
  );
};

export default EditorToolbar;
